<template>
  <div v-loading="loading">
    <TinyEditor ref="TinyEditor" v-if="visible" userType="admin" :value.sync="content" :readonly="false" :systemToken="token" v-bind="$attrs" v-on="$listeners" @ready="ready" @input="input" @change="contentChange" @wordCountChange="wordCountChange" />
    <slot name="contentSize"></slot>
  </div>
</template>
<script>
  import TinyEditor from "@wenwo-public/tiny-editor-module";
  import { getTokenNew } from "@/utils/userStorage.ts";

  export default {
    name: "customEditor",
    components: {
      TinyEditor,
    },
    props: {
      value: {
        type: String,
        default: "",
      },
      visible: {
        type: [Boolean, Number],
        default: true,
      },
    },
    watch: {
      value: {
        handler(newVal, oldVal) {
          if (this.$refs.TinyEditor) {
            this.$refs.TinyEditor.setContent(newVal);
          }
        },
        immediate: true,
      },
    },
    computed: {
      content: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit("update:value", val);
        },
      },
      show: {
        get() {
          return this.visible;
        },
        set(val) {
          this.$emit("update:visible", val);
        },
      },
      token: {
        get() {
          console.log("systemToken", getTokenNew());
          return "Bearer business=" + getTokenNew();
        },
      },
    },
    data() {
      return {
        initComplete: true,
        loading: true,
        complete: true,
        editable: true,
        editorInstance: null,
      };
    },
    methods: {
      input(content) {
        this.$emit("input", content);
      },
      focus(content) {
        this.$emit("focus", content);
        console.log(content);
      },
      ready(editorInstance) {
        this.editorInstance = editorInstance;
        this.loading = false;
        this.$emit("ready", editorInstance);
      },
      wordCountChange(len) {
        this.$emit("wordCountChange", len);
      },
      contentChange() {
        this.content = this.$refs.TinyEditor.editor.getContent();
        this.$emit("contentChange");
      },
      getContent() {
        return this.$refs.TinyEditor.getValue();
      },
      setContent(c) {
        this.$refs.TinyEditor.setContent(c);
      },
      showMessage(msg) {
        this.editorInstance.notificationManager.open({
          text: msg,
          type: "info",
          timeout: 2000,
        });
      },
      getContentLength() {
        return this.$refs.TinyEditor.wordCount;
      },
    },
    mounted() {
      console.log("$attrs", this.$attrs);
      console.log("$listeners", this.$listeners);
    },
  };
</script>
<style lang="less">
  .layout-content {
    position: relative;
    z-index: 200; //全屏
  }
  .tox-silver-sink {
    z-index: 2100 !important;
    display: block !important;
  }
</style>
